import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { getSellProductDetail, patchTradeRequest1, patchTradeRequest2, patchTradeRequest3, patchtradeReply, postTradeRequest, sellComplete1, sellComplete2, sellComplete3, sellComplete4, sellDelete1, sellDelete2, sellDelete3, sendReplay } from 'crud/auth.crud';

import { useLocation, useHistory } from "react-router-dom"
import moment from "moment";
import _ from "lodash";
import Util from "pages/Dashboard/Common/Util";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import chatLeft from "assets/images/chat_left.png"
import chatRight from "assets/images/chat_right.png"
import Modal from "components/RopikCustom/Modal"
import Default from "assets/images/default.png"

const typeArr = [
  {text: '퇴비', value: 'compost', color: '#023047'},
  {text: '사료', value: 'feed', color: '#2EB09F'},
  {text: '폐유', value: 'wasteoil', color: '#126782'},
]

import { useSelector } from "react-redux";
const SellDetailScreen = () => {
  const selector = useSelector(state => state)
  const history = useHistory()
  const location = useLocation()

  const [form, setForm] = useState('detail')
  const [type, setType] = useState(selector.auth.user?.type || "")
  const [id, setId] = useState(location.state.id);
  const [myCompany, setMyCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group);
  const [myProfile, setMyProfile] = useState(selector.auth?.user)
  const [data, setData] = useState({});
  const [onUpload, setOnUpload] = useState(false);
  const [tradeRequest, setTradeRequest] = useState({})
  const [related, setRelated] = useState(false)
  const [isMe, setIsMe] = useState(false)
  const [chatList, setChatList] = useState([])
  const [chat, setChat] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [modalShow, setModalShow] = useState(false)
  const [modalShow2, setModalShow2] = useState(false)
  const [requestQty, setRequestQty] = useState('')
  const [opponent, setOpponent] = useState('')
  const [currentSlide, setCurrentSlide] = useState(1)
  const [previewImage, setPreviewImage] = useState('')
  const [productType, setProductType] = useState('')

  const getData = async () => {
    const response = await getSellProductDetail(id);
    if (response.status === 200) {
      setData(response.data)
      const rqData = response.data?.request_list?.filter(itm => itm.status === 'Y')?.[0] || {};
      const related = response.data?.request_list?.filter(itm => itm.status === 'Y' && itm.member === myProfile.id).length > 0 || response.data.member === myProfile?.id
      const isMe = type === 'treatment' && response.data.member === myProfile?.id
      setTradeRequest(rqData)
      setRelated(related)
      setIsMe(isMe)
      setChatList(rqData.chat_list)
      setOpponent(type === 'treatment' ? response.data?.request_list?.filter(itm => itm.status === 'Y')?.[0]?.company_data?.name : response.data?.company_data?.name)
      setProductType(typeArr.find(v => v.value === response.data.product_type))
    }
    setIsLoading(false)
  }

  const openTrade = () => {
    if (confirm(`${data.subject} ${requestQty}Kg을 ${(requestQty || 0) * (data.price_per_kg || 0)}원에 구매요청을 하시겠습니까?`)) {
      doTradeRequest()
    }
  }

  const doTradeRequest = async () => {
    setOnUpload(true)
    setModalShow(false)
    const params = {
      trade: id,
      trade_request_id: tradeRequest?.id,
      company: myCompany.id,
      member: myProfile.id,
      qty: requestQty,
      price_per_kg: data?.price_per_kg,
      type: 'buy',
      state: 'N',
      status: 'Y',
    }
    const response = await postTradeRequest(params)
    if (response.status === 200) {
      alert(response.data.msg)
      getData()
    }
    setOnUpload(false)
    setRequestQty('')
  }

  const openTradeComplete = async () => {
    if (confirm(`${data.subject} ${tradeRequest.qty}Kg을 ${(tradeRequest.qty || 0) * (data.price_per_kg || 0)}원에 판매완료 하시겠습니까?`)) {
      const date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      const response = await sellComplete1(tradeRequest.id, date)
      if (response.status === 200) {
        const tradeRs = await sellComplete2(id, date)
        if (tradeRs.status === 200) {
          const params = {
            trade_id: id,
            company_id: myCompany.id,
            member_id: myProfile.id,
            qty: data?.qty,
            price_per_kg: data?.price_per_kg,
            complete_date: date,
            type: 'sell',
            state: 'Y',
            status: 'Y',
          }
          const rs = await sellComplete3(params)
          const params2 = {
            trade_id: id,
            company_id: tradeRequest.company,
            member_id: tradeRequest.member,
            qty: tradeRequest.qty,
            price_per_kg: data?.price_per_kg,
            complete_date: date,
            type: 'buy',
            state: 'Y',
            status: 'Y',
          }
          const rs2 = await sellComplete4(params2)
          if (rs2.status === 201) {
            alert('정상적으로 판매완료 되었습니다.')
            getData()
          }
        }
      }
    }
    return true;
  }

  const deleteTrade = async () => {
    if (confirm("판매를 취소하시겠습니까?")) {
      {
        const response = await sellDelete1(tradeRequest.id)
        if (response.status === 200) {
          const params = {
            trade_id: id,
            trade_request_id: tradeRequest.id,
            company_id: myCompany.id,
            member_id: myProfile.id,
            qty: tradeRequest.qty,
            price_per_kg: data?.price_per_kg,
            type: 'buy',
            state: 'N',
            status: 'N',
          }
          const tradeRs = await sellDelete2(id)
          if (tradeRs.status === 200) {
            const rs = await sellDelete3(params)
            if (rs.status === 201) {
              alert('정상적으로 판매취소 되었습니다.')
              getData()
            }
          }
        }
      }
    }
    return true;
  }
  
  const modalOpen2 = (item) => {
    setPreviewImage(item)
    setModalShow2(true)
  }
  
  const modalClose2 = () => {
    setModalShow2(false)
  }

  const handleSend = async () => {
    const params = {
      content: chat,
      status: 'Y',
      company: myCompany.id,
      member: myProfile.id,
      trade_request: tradeRequest?.id
    }

    const response = await sendReplay(params);
    setChat('')
    setChatList([...chatList, response.data])
  }

  const deleteTradeRequest = async () => {
    if (confirm('구매요청을 취소하시겠습니까?')) {
      const response = await patchTradeRequest1(tradeRequest.id)
      if (response.status === 200) {
        const params = {
          trade_id: id,
          company_id: myCompany.id,
          member_id: myProfile.id,
          qty: tradeRequest.qty,
          price_per_kg: data?.price_per_kg,
          type: 'buy',
          state: 'N',
          status: 'N',
        }
        const tradeRs = await patchTradeRequest2(id)
        if (tradeRs.status === 200) {
          const rs = await patchTradeRequest3(params)
          if (rs.status === 201) {
            alert('정상적으로 구매 취소 되었습니다.')
            getData()
          }
        }
      }
    }
    return true
  }

  const deleteChat = async (id) => {
    if (confirm('해당 댓글을 삭제하시겠습니까?')) {
      const rs = await patchtradeReply(id)
      if (rs.status === 200) {
        let tmp = [...chatList]
        tmp.filter(itm => itm.id === id)[0].status = 'N'
        setChatList(tmp)
      }
    }
    return true;
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>제품상세 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="상품 리스트" breadcrumbItem="제품 상세" />

          <Row style={{justifyContent: "center"}}>
            <Col xs="12" style={{ maxWidth: '51.5rem' }}>
              <div className="email-rightbar mb-3">
                <Card style={{border: '1px solid #D9D9D9', borderRadius: 0}}>
                  <CardBody style={{ padding: 24 }}>
                    {/* <div onClick={() => { history.goBack() }}
                      style={{ padding: '0.4rem 1rem', borderRadius: '0.2rem', marginBottom: 24, fontSize: 16 }}
                      className="btn btn-primary dropdown-toggle waves-effect waves-light bg-silver"
                    >목록으로
                    </div> */}
                    <Row>
                      <Col xl='6' style={{ height: 364, position: "relative", marginBottom: 24 }}>
                        <div style={{ width: 34, height: 22, textAlign: "center", lineHeight: '22px', borderRadius: 4, backgroundColor: 'rgba(0,0,0,0.5)', color: 'white', position: "absolute", bottom: 8, left: 0, right: 0, margin: '0 auto', zIndex: 10 }}>{currentSlide}/{data.trade_file ? data.trade_file.length : '0'}</div>
                        <Slider
                          dots={false}
                          infinite={true}
                          speed={500}
                          slidesToShow={1}
                          slidesToScroll={1}
                          afterChange={(current) => {
                            setCurrentSlide(current + 1)
                          }}
                        >
                          {data?.trade_file && data?.trade_file.map((item, index) => {
                            return (
                              <div key={item + index}>
                                <img style={{ width: '100%', height: 364, borderRadius: 4 }} src={item.path.replace("http://127.0.0.1:5010", "http://wasteverse.ropiklabs.com")} onClick={()=>{modalOpen2(item)}} onError={(e) => e.target.src = Default} />
                              </div>
                            )
                          })}
                        </Slider>
                      </Col>
                      <Col xl='6'>
                        <div style={{ width: 38, height: 24, backgroundColor: productType.color, textAlign: 'center'}} type="button" className={`border-radius-0 margin-right-4 font-size-11 line-height-1 white-text border-none margin-bottom-12`}>
                          <p className='mb-0' style={{lineHeight: '24px'}}>{productType.text}</p>
                        </div>
                        <p className="font-size-24 text-black mb-4 font-weight-bold">{data.subject}</p>
                        <p className="font-size-16 mb-0">재고: {Util.setPrice(data.qty)} kg</p>
                        <p className="font-size-16 mb-4">kg당 <span className="font-size-24 font-weight-bold">{Util.setPrice(data.price_per_kg)}</span> 원</p>
                        <p className="font-size-16 font-weight-bold mb-2">판매업체정보</p>
                        <p className="font-size-14 text-gray mb-0">{data.company_data?.name}</p>
                        <p className="font-size-14 text-gray mb-0">{Util.handlePhoneNumberChange(data.company_data?.phone)}</p>
                        <p className="font-size-14 text-gray mb-4">{data.address}</p>
                        {tradeRequest && !_.isEmpty(tradeRequest) && related &&
                          <>
                            <p className="font-size-16 font-weight-bold mb-2">구매신청정보</p>
                            <div className="d-flex justify-content-between mb-2">
                              <p className="font-weight-14 text-gray mb-0">연락처</p>
                              <p className="font-size-16 text-black mb-0">{Util.handlePhoneNumberChange(tradeRequest.company_data?.phone)}</p>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                              <p className="font-weight-14 text-gray mb-0">판매량</p>
                              <p className="font-size-16 text-black mb-0"><span className="font-weight-bold">{Util.setPrice(tradeRequest.qty)}</span> kg</p>
                            </div>
                            <div className="d-flex justify-content-between mb-4">
                              <p className="font-weight-14 text-gray mb-0">총합계금액</p>
                              <p className="font-size-16 text-black mb-0"><span className="font-weight-bold text-warning">{Util.setPrice((tradeRequest.qty || 0) * (tradeRequest.price_per_kg || 0))}</span> 원</p>
                            </div>
                          </>
                        }
                        <div className="d-flex justify-content-between w-100 mb-4">
                          {data.state !== 'Y' && type === 'treatment' && isMe &&
                            <Button
                              type="button"
                              color="silver"
                              style={{ padding: '0.5rem 0', borderRadius: '0.2rem', width: 'calc(50% - 12px)' }}
                              onClick={() => {
                                deleteTrade()
                              }}
                            >
                              판매 취소
                            </Button>
                          }
                          {data.state === 'U' && type === 'demand' && related &&
                            <Button
                              type="button"
                              color="silver"
                              style={{ padding: '0.5rem 0', borderRadius: '0.2rem', width: 'calc(50% - 12px)' }}
                              onClick={() => {
                                deleteTradeRequest()
                              }}
                            >
                              구매 취소
                            </Button>
                          }
                          {data.state === 'N' && type === 'demand' &&
                            <Button
                              type="button"
                              color="primary"
                              style={{ padding: '0.5rem 0', borderRadius: '0.2rem', width: '100%' }}
                              onClick={() => {
                                setModalShow(true)
                              }}
                            >
                              구매 요청
                            </Button>
                          }
                          {data.state === 'U' && isMe &&
                            <Button
                              type="button"
                              color="primary"
                              style={{ padding: '0.5rem 0', borderRadius: '0.2rem', width: 'calc(50% - 12px)' }}
                              onClick={() => {
                                openTradeComplete()
                              }}
                            >
                              판매 완료
                            </Button>
                          }
                          {data.state === 'Y' && !related &&
                            <Button
                              type="button"
                              color="light"
                              style={{ padding: '0.5rem 0', borderRadius: '0.2rem', width: '100%', cursor: 'auto', color: 'white', backgroundColor: '#A3A3A3' }}
                            >
                              거래완료
                            </Button>
                          }
                          {data.state === 'U' && !related &&
                            <Button
                              type="button"
                              color="light"
                              style={{ padding: '0.5rem 0', borderRadius: '0.2rem', width: '100%', cursor: 'auto', color: 'white', backgroundColor: '#2EB09F' }}
                            >
                              거래중
                            </Button>
                          }
                        </div>
                      </Col>
                    </Row>
                    <div style={{ marginBottom: 24 }}>
                      <p style={{ width: 110, color: '#333', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>상품상세</p>
                      <div style={{ width: '100%', padding: '16px 20px', borderRadius: 4, border: '1px solid #4DBBAA' }}>
                        <p style={{ fontSize: 13, lineHeight: '24px', marginBottom: 0 }} >{data.content}</p>
                      </div>
                    </div>
                    {tradeRequest && !_.isEmpty(tradeRequest) && related && data.state == 'U' &&
                      <div>
                        <p style={{ width: 110, color: '#333', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>댓글</p>
                        <Col xl={12}>
                          <div style={{ border: '1px solid #ced4da', width: '100%', height: 360, overflowY: "scroll", padding: 12, borderRadius: '8px 8px 0 0', backgroundColor: '#eee' }} >
                            {chatList?.length > 0 && chatList.map((item, index) => {
                              return (
                                <div key={index} style={{ width: '100%', display: "flex", fontSize: 16, justifyContent: myCompany.id === item.company ? 'flex-end' : "flex-start", marginTop: 8, marginBottom: 8 }}>
                                  {myCompany.id === item.company ?
                                    <>
                                      <Col xl={12} style={{ display: "flex", backgroundColor: 'white', borderRadius: 16, maxWidth: 240, padding: 16, justifyContent: "space-between", marginRight: -2 }}>
                                        <div>
                                          <p style={{ fontSize: 12, marginBottom: 4, color: '#bdbdbd' }}>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                                          <p style={{ color: item.status === 'N' && '#8A8A8A', marginBottom: 0 }}>{item.status === 'Y' ? item.content : '삭제된 댓글입니다.'}</p>
                                        </div>
                                        <p style={{ fontSize: 12, color: '#ff4949', cursor: "pointer", display: item.status === 'Y' ? "block" : "none" }} onClick={() => {
                                          deleteChat(item.id)
                                        }}>삭제</p>
                                      </Col>
                                      <img style={{ width: 15, height: 9, marginTop: 24 }} src={chatRight} onError={(e) => e.target.src = Default} />
                                    </>
                                    :
                                    <>
                                      <img style={{ width: 15, height: 9, marginTop: 24 }} src={chatLeft} onError={(e) => e.target.src = Default} />
                                      <Col xl={12} style={{ display: "flex", backgroundColor: 'white', borderRadius: 16, maxWidth: 240, padding: 16, justifyContent: "space-between", marginLeft: -2 }}>
                                        <div>
                                          <p style={{ fontSize: 12, marginBottom: 4, color: '#bdbdbd' }}>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                                          <p style={{ color: item.status === 'N' && '#8A8A8A', marginBottom: 0 }}>{item.status === 'Y' ? item.content : '삭제된 댓글입니다.'}</p>
                                        </div>
                                      </Col>
                                    </>
                                  }
                                </div>
                              )
                            })}
                          </div>
                          <div style={{ width: '100%', display: 'flex', height: 42 }}>
                            <input className="is-touched is-dirty av-valid form-control" style={{ marginTop: 3, flexGrow: 1 }} value={chat} onKeyPress={(e) => {
                              if (e.key == 'Enter') {
                                handleSend()
                              }
                            }} onChange={(e) => {
                              setChat(e.target.value)
                            }} />
                            <input type="button" className="btn btn-primary waves-effect waves-light" style={{ margin: '3px 0 0 6px', width: 56 }} onClick={() => {
                              handleSend()
                            }} value="전송" />
                          </div>
                        </Col>
                      </div>
                    }
                  </CardBody>

                </Card>
                <div className="waver-pagination-btn-group justify-content-between d-flex">
                  <button style={{ width: 100, height: 35 }} type="button" className="border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none"  onClick={() => { history.goBack() }}>
                    목록으로
                  </button>
                  {isMe &&
                  <button style={{ width: 100, height: 35 }} type="button" className="border-radius-0 margin-right-4 font-size-11 line-height-1 primary-bg white-text border-none"  onClick={() => { history.push(`/sell-request-update?id=${id}`) }}>
                    상품수정
                  </button>
                  }
                </div>
              </div>
            </Col>
          </Row>

        </Container>
      </div>
      {modalShow && <div style={{
        position: "fixed",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{ width: 480, height: 480, backgroundColor: "#fff", zIndex: 1000, padding: 36 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 20, color: 'black', fontWeight: 'bold' }}>{data.subject}</p>
            <p style={{ cursor: "pointer", fontSize: 20 }} onClick={() => {
              setModalShow(false)
              setRequestQty('')
            }}>X</p>
          </div>
          <div style={{ padding: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>Kg당 요금</p>
              <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{data.price_per_kg} 원</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>최대 수량</p>
              <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{data.qty} Kg</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>구매 수량</p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <input style={{ width: 72, height: 30, padding: 6, marginLeft: '0.5rem', marginRight: 6 }} placeholder="수량" className="form-control" onChange={(e) => {
                  setRequestQty(e.target.value)
                }}></input>
                <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>Kg</p>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 16 }}>구매 가격</p>
              <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{(requestQty || 0) * (data.price_per_kg || 0)} 원</p>
            </div>
          </div>
          <Button
            type="button"
            color="warning"
            style={{ padding: '0.4rem 1.75rem', borderRadius: '0.2rem', float: "right" }}
            onClick={() => {
              openTrade()
            }}
          >
            구매 요청
          </Button>
        </div>
      </div>}

      <Modal title={'상품 자세히 보기'} show={modalShow2} onHide={modalClose2} size="xl">
        <div style={{ zIndex: 1, minHeight : '300px', width: '100%', display: "flex", justifyContent: "center", flexDirection: 'column' }}>
          <img style={{
            margin: '0 auto 24px',
            width: '90%',
          }}
          src={previewImage?.path && previewImage?.path.replace("http://127.0.0.1:5010", "http://wasteverse.ropiklabs.com")}
          onError={(e) => e.target.src = Default} />
        </div>
        {data?.trade_file && data?.trade_file.map((item, index)=>{return (
          <img style={{width: 60, height: 60, marginRight: 10, opacity: item.path !== previewImage.path && 0.4, cursor: "pointer"}} src={item.path.replace("http://127.0.0.1:5010", "http://wasteverse.ropiklabs.com")} onClick={()=>{setPreviewImage(item)}}
          onError={(e) => e.target.src = Default} />
        )})}
      </Modal>
    </React.Fragment>
  )
}

export default SellDetailScreen
